import type { ReactNode } from 'react';
import { AuthShell } from './LoginPage';

/** Registro y recuperación de contraseña con el mismo estilo que el inicio de sesión (barra negra, estilo Uber). */
export function AuthLayout({ title, subtitle, children, footer }: { title: string; subtitle?: string; children: ReactNode; footer?: ReactNode }) {
  return (
    <AuthShell>
      <div>
        <h1 className="text-2xl font-semibold leading-snug">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-[var(--text-muted)]">{subtitle}</p>}
      </div>
      <div>{children}</div>
      {footer && <div className="text-sm text-center">{footer}</div>}
    </AuthShell>
  );
}
